(function () {

    var DEV = 0;

    document.addEventListener('DOMContentLoaded', function () {
        var scrollButtons = document.querySelectorAll('[scroll-to]');

        function smoothScrollTo(targetId, offset) {
            var targetElement = document.getElementById(targetId);

            if (targetElement) {
                var targetOffset = targetElement.offsetTop + offset;
                DEV && log('targetOffset', targetOffset)
                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth'
                });
            }
        }

        // Attach click event listener to each scroll button
        scrollButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                var targetId = button.getAttribute('scroll-to');
                var offset = parseInt(button.getAttribute('offset')) || 0;
                DEV && log('offset', offset)
                smoothScrollTo(targetId, offset);
            });
        });
    });
})();
